//自己封装的uni.request工具类
import { getWxConfig } from "./api.js";
// var wechat = require('weixin-js-sdk');
var jweixin = require("jweixin-module");
// import wechat from 'weixin-js-sdk'
export default {
  //判断是否在微信中
  isWechat: function() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/i) == "micromessenger") {
      ////console.log('是微信客户端')
      return true;
    } else {
      ////console.log('不是微信客户端')
      return false;
    }
  },
  //初始化sdk配置
  async initJssdkShare(callback, _url) {
    let params = {
      url: _url,
    };
    let data = await getWxConfig(params);
    //console.log('configData',data)
    if (data.code == 0) {
      jweixin.config({
        debug: false,
        appId: data.data.appId,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: data.data.jsApiList,
      });
      //配置完成后，再执行分享等功能
      if (callback) {
        callback();
      }
    }
  },
  //在需要自定义分享的页面中调用
  share: function(data, url) {
    url = url ? url : window.location.href.split("#")[0];
    //每次都需要重新初始化配置，才可以进行分享
    this.initJssdkShare(function(signData) {
      jweixin.ready(function() {
        var shareData = {
          title: data.title,
          desc: data.desc,
          link: url,
          imgUrl: data.img,
          success: function(res) {
            //分享后的一些操作,比如分享统计等等
            //console.log('res', res)
          },
          cancel: function(err) {
            //console.log('err', err)
          },
        };
        //分享给朋友接口
        jweixin.updateAppMessageShareData(shareData);
        // //分享到朋友圈接口
        jweixin.updateTimelineShareData(shareData);
      });
    }, url);
  },
};
